import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/base/SEO';

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '¿Cuándo es gratis el vaciado de un piso?',
      answer: 'El vaciado es gratuito cuando los muebles, electrodomésticos u objetos tienen valor suficiente para compensar el coste del trabajo, transporte y gestión. Evaluamos cada caso individualmente. Si el valor no compensa, te damos un presupuesto claro y ajustado. No todos los vaciados pueden ser gratis, depende del contenido.'
    },
    {
      question: '¿Cómo se hace la valoración?',
      answer: 'Puedes enviarnos fotos y vídeos por WhatsApp al 633 759 649 o programar una visita presencial gratuita. Evaluamos el estado, cantidad y tipo de objetos. Te damos una respuesta en 24-48 horas con propuesta clara: vaciado gratis, vaciado con coste, o compra de muebles específicos.'
    },
    {
      question: '¿Qué muebles compráis?',
      answer: 'Compramos únicamente muebles de diseño firmados (Eames, Thonet, Cassina, etc.) o antigüedades auténticas de más de 100 años con valor histórico. NO compramos muebles comunes de Ikea, Conforama o similares. Estos se pueden retirar dentro del servicio de vaciado con presupuesto. Envíanos fotos, marca, medidas y estado para valorar.'
    },
    {
      question: '¿Cuánto cuesta vaciar un piso?',
      answer: 'El precio depende de: superficie (m²), volumen de objetos, accesos (ascensor, escaleras, distancia al camión), desmontajes necesarios, urgencia, y tipo de residuos. Un piso de 60m² con ascensor puede costar entre 300-600€ si no hay valor compensatorio. Te damos presupuesto personalizado tras evaluación.'
    },
    {
      question: '¿En cuánto tiempo podéis vaciar un piso?',
      answer: 'Un piso estándar (60-80m²) se vacía en 3-6 horas con nuestro equipo. Pisos más grandes o con muchos objetos pueden requerir 1-2 días. Podemos adaptarnos a urgencias. Tras aceptar el presupuesto, solemos programar el vaciado en 3-7 días, según disponibilidad.'
    },
    {
      question: '¿Qué hacéis con los electrodomésticos?',
      answer: 'Los electrodomésticos en buen estado se pueden revender o donar. Los que no funcionan se gestionan como residuos electrónicos según normativa (RAEE) a través de gestores autorizados cuando aplique. Si tienen valor, pueden compensar el coste del vaciado.'
    },
    {
      question: '¿Gestionáis los residuos legalmente?',
      answer: 'Sí. Trabajamos según normativa vigente y utilizamos gestores autorizados cuando aplique para residuos especiales (electrónicos, voluminosos, etc.). Los muebles y objetos reutilizables se destinan a reventa o donación. Te podemos facilitar documentación si la necesitas.'
    },
    {
      question: '¿Necesito permisos para vaciar mi piso?',
      answer: 'Normalmente no se necesitan permisos municipales para un vaciado estándar. En algunos casos (ocupación de vía pública con camión, uso prolongado de ascensor) puede ser recomendable avisar a la comunidad de vecinos. Te asesoramos según tu situación.'
    },
    {
      question: '¿Qué pasa con objetos personales o documentos?',
      answer: 'Tratamos todo con máxima discreción. Si hay objetos personales, documentos o fotos, los separamos y te consultamos antes de gestionar nada. Recomendamos que revises el piso antes del vaciado y retires lo que quieras conservar. Nosotros te ayudamos a identificar qué puede tener valor.'
    },
    {
      question: '¿Incluye limpieza final?',
      answer: 'La limpieza final es un servicio opcional. Tras el vaciado, el piso queda libre de muebles y enseres, pero puede necesitar limpieza profunda para entrega a propietario, venta o alquiler. Ofrecemos este servicio adicional, consúltanos precio.'
    },
    {
      question: '¿En qué zonas de Barcelona trabajáis?',
      answer: 'Trabajamos en Barcelona ciudad y toda el área metropolitana: L\'Hospitalet, Badalona, Santa Coloma, Cornellà, El Prat, Sant Boi, Castelldefels, Gavà, Viladecans, Esplugues, Sant Just, Sant Joan Despí, Sant Cugat, Cerdanyola, Montcada i Reixac, Mataró, Sabadell, Terrassa y más municipios de la provincia. Consúltanos tu ubicación.'
    },
    {
      question: '¿Qué debo enviar por WhatsApp para una valoración?',
      answer: 'Envíanos fotos o vídeo del piso (general y detalles de muebles), indica: municipio, m² aproximados, si hay ascensor, si hay muebles de diseño o antigüedades (marca, medidas, estado), y cuándo necesitas el vaciado. Con eso podemos darte una primera valoración rápida. WhatsApp: 633 759 649.'
    }
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "VACIADOS MARIUS",
    "@id": `${import.meta.env.VITE_SITE_URL || 'https://vaciado-pisos-barcelona.vaciadosmarius.com.es'}/#organization`,
    "url": import.meta.env.VITE_SITE_URL || "https://vaciado-pisos-barcelona.vaciadosmarius.com.es/",
    "telephone": "+34936940041",
    "email": "vaciadosmarius@gmail.com",
    "sameAs": "https://share.google/FizsQeezE7RkuyEkt"
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Inicio",
        "item": import.meta.env.VITE_SITE_URL || "https://vaciado-pisos-barcelona.vaciadosmarius.com.es/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Preguntas Frecuentes",
        "item": `${import.meta.env.VITE_SITE_URL || 'https://vaciado-pisos-barcelona.vaciadosmarius.com.es'}/faq`
      }
    ]
  };

  return (
    <>
      <SEO
        title="Preguntas Frecuentes Vaciado Pisos Barcelona | FAQ | VACIADOS MARIUS"
        description="Resuelve tus dudas sobre vaciado de pisos en Barcelona: cuándo es gratis, qué muebles compramos, plazos, precios y más. Llamar 936 94 00 41."
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://vaciado-pisos-barcelona.vaciadosmarius.com.es'}/faq`}
        keywords="preguntas vaciado pisos Barcelona, FAQ vaciado gratis, dudas recogida muebles, precio vaciado Barcelona"
        geoRegion="ES-CT"
        geoPlacename="Barcelona"
        geoPosition="41.3851;2.1734"
        jsonLd={[localBusinessSchema, faqSchema, breadcrumbSchema]}
      />

      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <nav className="text-sm text-gray-600 mb-8">
              <Link to="/" className="hover:text-teal-600 cursor-pointer">Inicio</Link>
              <span className="mx-2">&gt;</span>
              <span className="text-gray-900">Preguntas Frecuentes</span>
            </nav>

            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                Preguntas frecuentes sobre vaciado de pisos
              </h1>
              <p className="text-xl text-gray-600">
                Resolvemos tus dudas más comunes
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Accordion */}
        <section className="bg-white py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
                  >
                    <span className="text-lg font-bold text-gray-900 pr-4">
                      {faq.question}
                    </span>
                    <i
                      className={`text-2xl text-teal-600 transition-transform duration-300 flex-shrink-0 ${
                        openIndex === index ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'
                      }`}
                    ></i>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openIndex === index ? 'max-h-96' : 'max-h-0'
                    }`}
                  >
                    <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                      {faq.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA After FAQ */}
        <section className="bg-teal-50 py-16">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              ¿Tu pregunta no está aquí?
            </h2>
            <p className="text-gray-700 mb-8">
              Contacta con nosotros y te ayudaremos con cualquier duda. También puedes consultar información detallada en nuestra <a href="/empresa" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">página de empresa</a> o ver todos nuestros <a href="/servicios" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">servicios de vaciado</a>.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
              <a
                href="tel:+34936940041"
                className="flex items-center space-x-2 px-8 py-4 bg-teal-600 text-white rounded-full font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-xl"></i>
                <span>LLAMAR 936 94 00 41</span>
              </a>
              <a
                href="https://wa.me/34633759649"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 px-8 py-4 bg-green-600 text-white rounded-full font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-xl"></i>
                <span>WHATSAPP 633 759 649</span>
              </a>
            </div>
            <p className="text-gray-600">
              O visita nuestra <Link to="/contacto" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">página de contacto</Link>
            </p>
          </div>
        </section>

        {/* Additional Help Section */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
              Más información útil
            </h2>

            <div className="grid md:grid-cols-3 gap-8">
              <Link
                to="/servicios"
                className="group bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all cursor-pointer"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mb-4 group-hover:bg-teal-600 transition-colors">
                  <i className="ri-service-line text-teal-600 text-2xl group-hover:text-white transition-colors"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Nuestros servicios</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Descubre todos los servicios de vaciado que ofrecemos en Barcelona: vaciado completo, recogida selectiva, herencias, reformas, compra de muebles y limpieza final
                </p>
                <span className="text-teal-600 font-semibold text-sm flex items-center">
                  Ver servicios
                  <i className="ri-arrow-right-line ml-2"></i>
                </span>
              </Link>

              <Link
                to="/empresa"
                className="group bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all cursor-pointer"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mb-4 group-hover:bg-teal-600 transition-colors">
                  <i className="ri-team-line text-teal-600 text-2xl group-hover:text-white transition-colors"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Quiénes somos</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Conoce nuestro equipo y método de trabajo profesional. Más de 15 años de experiencia en vaciado de pisos en Barcelona con transparencia y discreción
                </p>
                <span className="text-teal-600 font-semibold text-sm flex items-center">
                  Sobre nosotros
                  <i className="ri-arrow-right-line ml-2"></i>
                </span>
              </Link>

              <Link
                to="/contacto"
                className="group bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all cursor-pointer"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mb-4 group-hover:bg-teal-600 transition-colors">
                  <i className="ri-mail-line text-teal-600 text-2xl group-hover:text-white transition-colors"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Solicita presupuesto</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Pide tu presupuesto gratuito sin compromiso. Respuesta en 24-48 horas. Evaluación personalizada de tu caso
                </p>
                <span className="text-teal-600 font-semibold text-sm flex items-center">
                  Contactar
                  <i className="ri-arrow-right-line ml-2"></i>
                </span>
              </Link>
            </div>
            <div className="text-center mt-12">
              <p className="text-gray-600">
                ¿Quieres saber más sobre nuestras zonas de cobertura? <a href="/#cobertura" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">Ver todas las zonas donde trabajamos</a>
              </p>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
